// صفحة مهام برهان - التصميم والمنطق موحّدين بـ components/EmployeeTasksPage.jsx
import React from "react";
import EmployeeTasksPage from "./components/EmployeeTasksPage";

const BurhanTasks = () => (
  <EmployeeTasksPage employeeName="برهان" title="الورشة" backPath="/Burhan-Tasks" />
);

export default BurhanTasks;
